/**
 * Ensure muted banner / hero videos actually start.
 * Some browsers ignore the autoplay attribute until play() is called.
 */
const playAutoplayVideos = () => {
	document.querySelectorAll("video[autoplay]").forEach((video) => {
		video.muted = true
		const attempt = video.play()
		if (attempt && typeof attempt.catch === "function") {
			attempt.catch(() => {
				// Autoplay blocked — keep muted and retry once on first interaction
				const retry = () => {
					video.play().catch(() => {})
					window.removeEventListener("pointerdown", retry)
				}
				window.addEventListener("pointerdown", retry, { once: true })
			})
		}
	})
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", playAutoplayVideos)
} else {
	playAutoplayVideos()
}

export default playAutoplayVideos
